import * as types from './action-types';
import axios from 'axios';
import { apiATC } from '../config';
import { JOURS, JOURNEE_TYPE, parseDecimal, decimalHoursToHHMM, timeToMinutes, getWeekBoundaries } from '../utils/releveHeures';

const endpoint = `${apiATC}/commercial/functions.php`;

const logError = (error) => console.error(error);

export const setReleveHeuresSemaine = (weekString) => ({ type: types.RELEVE_HEURES_SET_WEEK, payload: weekString });

export const setReleveHeuresExpandedDay = (jour) => ({ type: types.RELEVE_HEURES_SET_EXPANDED_DAY, payload: jour });

export const setReleveHeuresChamp = (jour, field, value) => ({
    type: types.RELEVE_HEURES_SET_CHAMP,
    payload: { jour, field, value }
});

export const setReleveHeuresJournee = (jour, valeurs) => ({
    type: types.RELEVE_HEURES_SET_JOURNEE,
    payload: { jour, valeurs }
});

export const setReleveHeuresMeta = (meta) => ({ type: types.RELEVE_HEURES_SET_META, payload: meta });

export const appliquerJourneeType = (jour) => setReleveHeuresJournee(jour, JOURNEE_TYPE);

export const appliquerSemaineType = () => (dispatch) => {
    ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi'].forEach(jour => {
        dispatch(setReleveHeuresJournee(jour, JOURNEE_TYPE));
    });
};

// Une réponse est obsolète si l'utilisateur a changé de semaine avant que la requête n'aboutisse
const estReponseObsolete = (getState, annee, semaine) => {
    const { year, week } = getWeekBoundaries(getState().releveHeures.weekString);
    return year !== annee || week !== semaine;
};

// Fonction utilitaire pour garantir un format HH:mm (ex: "01:00:00" -> "01:00")
const formatHHMM = (timeStr) => {
    if (!timeStr) return '';
    return timeStr.length > 5 ? timeStr.substring(0, 5) : timeStr;
};

export const chargerReleveHeures = (userId, annee, semaine) => async (dispatch, getState) => {
    dispatch({ type: types.RELEVE_HEURES_LOAD_REQUEST });
    try {
        const res = await axios.get(endpoint, { params: { annee, numero_semaine: semaine, id_utilisateur: userId } });

        if (estReponseObsolete(getState, annee, semaine)) return;

        if (res.data?.success && res.data?.donnees) {
            const { entete, details: detailsBDD } = res.data.donnees;
            const details = {};
            (detailsBDD || []).forEach(item => {
                const jourKey = item.nom_jour.toLowerCase();
                const brutValDecimal = parseDecimal(item.heures_deplacement_brutes);
                details[jourKey] = {
                    debut: formatHHMM(item.heure_debut),
                    fin: formatHHMM(item.heure_fin),
                    pause: formatHHMM(item.duree_interruption) || '01:00', // <--- Nettoyé ici
                    depBrut: decimalHoursToHHMM(brutValDecimal),
                    obs: item.observations || ''
                };
            });

            dispatch({
                type: types.RELEVE_HEURES_LOAD_SUCCESS,
                payload: {
                    statut: entete.statut,
                    details,
                    meta: {
                        reposRespectes: Number(entete.repos_respectes) === 1 ? 'oui' : 'non',
                        remarquesRepos: entete.remarques_repos || '',
                        dateSignature: entete.date_signature || null,
                        adresseIp: entete.adresse_ip || null,
                        empreinteSha256: entete.empreinte_sha256 || null
                    }
                }
            });
        } else {
            dispatch({ type: types.RELEVE_HEURES_LOAD_SUCCESS, payload: { statut: 'BROUILLON', details: null, meta: null } });
        }
    } catch (err) {
        if (estReponseObsolete(getState, annee, semaine)) return;
        logError(err);
        dispatch({ type: types.RELEVE_HEURES_LOAD_FAILURE, error: 'Erreur lors du chargement du relevé.' });
    }
};

export const soumettreReleveHeures = ({ userId, annee, semaine, totalSemaine, details, meta, action }) => async (dispatch) => {
    dispatch({ type: types.RELEVE_HEURES_SAVE_REQUEST });
    try {
        const detailsComplets = {};
        JOURS.forEach(jour => {
            const jourKey = jour.toLowerCase();
            const d = details[jourKey];
            const brutHours = timeToMinutes(d.depBrut) / 60;
            // Plus de déduction par jour : la déduction forfaitaire (1h30) est appliquée une seule fois au niveau de la semaine
            detailsComplets[jourKey] = { ...d, depBrut: brutHours, depNet: brutHours };
        });

        const res = await axios.post(endpoint, {
            id_utilisateur: userId,
            annee,
            numero_semaine: semaine,
            total_heures_semaine: totalSemaine,
            repos_respectes: meta.reposRespectes === 'oui' ? 1 : 0,
            remarques_repos: meta.remarquesRepos,
            action,
            image_signature: meta.signatureName ? `SIG_${meta.signatureName}` : null,
            details: detailsComplets
        });

        if (res.data?.success) {
            dispatch({ type: types.RELEVE_HEURES_SAVE_SUCCESS });
            return { success: true, message: res.data.message };
        }

        const error = res.data ? res.data.error : "Impossible d'enregistrer";
        dispatch({ type: types.RELEVE_HEURES_SAVE_FAILURE, error });
        return { success: false, error };
    } catch (err) {
        logError(err);
        const error = "Erreur serveur lors de l'enregistrement.";
        dispatch({ type: types.RELEVE_HEURES_SAVE_FAILURE, error });
        return { success: false, error };
    }
};
